export const AVATAR_COLORS = ['#2A9D8F', '#4A78B5', '#8E6FB5', '#E07856', '#5B9F6E', '#C56B8E', '#3E8E9E', '#B5793F'];

function hashString(value: string): number {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) | 0;
    }
    return hash;
}

export function getAvatarColor(seed: number | string): string {
    const index = typeof seed === 'number' ? seed : hashString(seed);
    return AVATAR_COLORS[Math.abs(index) % AVATAR_COLORS.length];
}
